import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  text: {
    width: pxToRem(320),
    fontSize: pxToRem(14),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'wrap',
    paddingRight: pxToRem(20),
  },
  productText: {
    width: pxToRem(320),
    fontSize: pxToRem(12),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingRight: pxToRem(20),
  },
  moreProductIds: {
    color: theme.palette.themePrimary,
  },
  tooltipContent: {
    margin: pxToRem(10),
    padding: pxToRem(15),
  },
  nested: {
    fontSize: pxToRem(12),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingRight: pxToRem(20),
  },
});
